module.exports = __webpack_public_path__ + "static/service-branding-ae2e5a9ad18fd5dda64244417154b66a.svg";